export default __webpack_public_path__ + "static/media/bball.75ea84fa.png";